import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWideNotification: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleWideNotification"><Path d="M13.5 3.50003L2.5 3.50002V18.5L9.0155 18.5L11.9979 21L15.0155 18.5H21.5V11.5M22.5 6C22.5 7.933 20.933 9.5 19 9.5C17.067 9.5 15.5 7.933 15.5 6C15.5 4.067 17.067 2.5 19 2.5C20.933 2.5 22.5 4.067 22.5 6Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubbleWideNotification;
